const validatePayment = data => {
  const errors = [];

  if (!data.paymentMethod || typeof data.paymentMethod !== "string") {
    errors.push("paymentMethod is required and must be a string.");
  }

  if (!data.paymentMethodAlias || typeof data.paymentMethodAlias !== "string") {
    errors.push("paymentMethodAlias is required and must be a string.");
  }

  if (!data.cardModel || typeof data.cardModel !== "object") {
    errors.push("cardModel must be an object.");
  } else {
    const {
      card_code,
      card_number,
      expiration_month,
      expiration_year,
      name_on_card
    } = data.cardModel;

    if (typeof card_code !== "string")
      errors.push("card_code must be a string.");
    if (typeof card_number !== "string")
      errors.push("card_number must be a string.");
    if (typeof name_on_card !== "string")
      errors.push("name_on_card must be a string.");
    if (typeof expiration_month !== "string")
      errors.push("expiration_month must be a string.");
    if (typeof expiration_year !== "string")
      errors.push("expiration_year must be a string.");
  }

  if (typeof data.offer !== "number" || data.offer <= 0) {
    errors.push("offer must be a positive number.");
  }

  if (
    data.subscriptionId !== null &&
    typeof data.subscriptionId !== "string" &&
    typeof data.subscriptionId !== "number"
  ) {
    errors.push("subscriptionId must be null, string, or number.");
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

export default validatePayment;
